var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ask-skeleton-loader"},[_c('div',{staticClass:"loader-bar-wrapper"},_vm._l((3),function(index){return _c('span',{key:index,staticClass:"skeleton-loader-gradient"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }